export type OrgDetailTab = "overview" | "plan" | "billing" | "members" | "support-access" | "projects";

export const ORG_DETAIL_TABS: readonly { value: OrgDetailTab; label: string }[] = [
  { value: "overview", label: "Overview" },
  { value: "plan", label: "Plan" },
  { value: "billing", label: "Billing" },
  { value: "members", label: "Members" },
  { value: "support-access", label: "Support Access" },
  { value: "projects", label: "Projects" },
];

/**
 * A7Y-4957: Support Access lists and creates grants, both superadmin-only on
 * the API, so the tab is shown to superadmins alone.
 */
export function visibleOrgDetailTabs(isSuperAdmin: boolean) {
  return ORG_DETAIL_TABS.filter((tab) => tab.value !== "support-access" || isSuperAdmin);
}
